// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/disponibilidad-flights',
    name: 'disponibilidad-flights',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/booking/cotizador/disponibilidad/flights/Index.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'cotizador',
    },
  },
]

export default formTable
